/**
 * @name Midpoint (中点横线指标)
 * @description 只在倒数第二根K线的中点位置画横线
 */

import { registerIndicator } from 'klinecharts';

// Register Midpoint indicator
registerIndicator({
  name: "Midpoint",
  shortName: "中点",
  figures: [],
 
  calcParams: {
    show: 1,                           // 显示开关 [1=显示, 0=隐藏]
    lineWidth: 2,                      // 线宽 [1-3]
    lineColor: '#ff6600',              // 线条颜色 (橙色)
  },

  calc: (dataList) => {
    return dataList.map((data, index) => {
      const { high, low } = data;
      const isSecondLast = index === dataList.length - 2;
      
      return {
        midpoint: isSecondLast ? (high + low) / 2 : null
        // midpoint: (high + low) / 2
      };
    });
  },

  draw: ({ ctx, chart, indicator, bounding, xAxis, yAxis }) => {
    const { from, to } = chart.getVisibleRange();
    const { gapBar, halfGapBar } = chart.getBarSpace();
    const { result, calcParams } = indicator;

    if (calcParams.show === 0) return false;

    ctx.save();
    ctx.strokeStyle = calcParams.lineColor;
    ctx.lineWidth = calcParams.lineWidth;
    
    for (let i = from; i < to; i++) {
      const data = result[i];
      if (!data || data.midpoint == null) continue;

      const x = xAxis.convertToPixel(i);
      const y = yAxis.convertToPixel(data.midpoint);
      const lineLeft = x - halfGapBar;
      const lineRight = x + halfGapBar;
      
      // 绘制横线
      ctx.beginPath();
      ctx.moveTo(lineLeft, y);
      ctx.lineTo(lineRight, y);
      ctx.stroke();
    }
    
    ctx.restore();
    return false;
  },

});
